import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import BackButton from "../../../assets/BackButton.svg";
import ForwardButton from "../../../assets/ForwardButton.svg";
import { GlobalContext } from "../../../context/GlobalContext";
import OrderListCard from "./OrderListCard";

export interface Props {
  rtl: boolean;
}

function OrderList({ rtl }: Props) {
  const [state, dispatch]: any = useContext(GlobalContext);
  const { trackCrNumberData } = state;

  const { t } = useTranslation();
  const backButton = rtl ? ForwardButton : BackButton;
  const dir = rtl ? "right" : "left";

  const handleBack = () => {
    dispatch({
      type: "INITIAL_ONLOAD_TRACK_ORDER",
      payload: { page: t("Track_my_order") },
    });
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-12 orderList-container">
          <img
            src={backButton}
            onClick={handleBack}
            className={`myOrders-backButton group-${dir}`}
            alt="backbutton"
          />
          <div className={`order-typography group-${dir}`}>
            <Typography className={`orderList-title arabicBold-${dir} `} rtl={rtl}>
              {t("Latest_order_status")}
            </Typography>
          </div>
          <div className={`orderList-info-group  group-${dir}`}>

            {trackCrNumberData.map((selectedOrder: any, index: any) => (
             <OrderListCard key={selectedOrder.CDOC_ID+index} rtl={rtl} selectedOrder={selectedOrder} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrderList;